<template>
  <component v-bind:is="layout"></component>
</template>

<script>
import AppLayout from './layouts/AppLayout'
import AuthLayout from './layouts/AuthLayout'
import MerchantLayout from './layouts/MerchantLayout'
import store from '@/store'
import swal from 'sweetalert'

export default {
  name: 'app',
  data: function () {
    return {
      loggedIn: store.state.isLoggedIn
    }
  },
  created: function () {
    if (store.state.isLoggedIn) {
      // Show the normal page
    } else {
      this.$router.push('/login')
    }
  },
  mounted: function () {
    var that = this

    // Enables push norifications if compiled as native app
    if (typeof PushNotification !== 'undefined') {
      this.setupPush()
    }

    // Configure AJAX requests with loaders, headers etc.
    $.ajaxSetup({
      async: true,
      dataType: 'json',
      beforeSend: function (xhr) {
        $.showLoading()

        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      error: function (data) {
        var error = ''
        if (typeof data.responseJSON.meta.reason !== 'undefined') {
          error = data.responseJSON.meta.reason
        } else if (data.responseJSON.message !== '') {
          error = data.responseJSON.message
        }

        if (error === 'Your token does not appear to be valid.') {
          that.$router.push('/login')
        } else {
          swal({
            title: 'Error',
            text: error,
            icon: 'error',
            button: 'Ok'
          })
        }

        $.hideLoading()
      },
      complete: function () {
        $.hideLoading()
      }
    })
  },
  computed: {
    layout () {
      return this.$store.getters.layout
    }
  },
  components: {
    'AppLayout': AppLayout,
    'AuthLayout': AuthLayout,
    'MerchantLayout': MerchantLayout
  },
  methods: {
    setupPush: function () {
      var apiUrl = this.$config.apiUrl

      // eslint-disable-next-line
      var push = PushNotification.init({
        'android': {
          'senderID': '77395875010'
        },
        'ios': {
          'sound': true,
          'alert': true,
          'badge': true
        },
        'windows': {}
      })

      push.on('registration', function (data) {
        var oldRegId = window.localStorage.getItem('deviceId')

        if (oldRegId !== data.registrationId) {
          window.localStorage.setItem('deviceId', data.registrationId)
        }

        // We also need to update it using Byron's API Call
        var token = {
          push_token: data.registrationId
        }

        window.localStorage.setItem('push_token', window.localStorage.getItem('deviceId'))

        // We wanna do this async in the background. So don't show/hide loading stuff
        $.ajax({
          beforeSend: function (xhr) {
            if (window.localStorage.getItem('token')) {
              xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
            }
          },
          url: apiUrl + 'basic/token',
          type: 'post',
          data: JSON.stringify(token),
          error: function (data) {
            // Do nothing
          },
          complete: function () {
            // Don't unshow loading bar
          }
        })
      })

      push.on('notification', function (data) {
        navigator.notification.alert(
          data.message, // message
          null, // callback
          data.title, // title
          'Ok' // buttonName
        )
      })
    }
  }
}

</script>
